// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.olt-log-main {
    background-color: #0d1117;
    display: flex;
    flex-direction: column;
    color: #c9d1d9;
}

/* Header Container */
.olt-log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #161b22;
    padding: 10px 15px;
    border-radius: 6px;
    border: 1px solid #30363d;
    margin-bottom: 15px;
}

.title-text {
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0;
    color: #f0f6fc;
    letter-spacing: 0.5px;
}

/* Buttons and Controls */
.back-button {
    background-color: #238636;
    color: #ffffff;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: background-color 0.2s;
}

.back-button:hover {
    background-color: #2ea043;
}

.header-controls {
    display: flex;
    gap: 8px;
    align-items: center;
}

.olt-select {
    background-color: #21262d;
    color: #c9d1d9;
    border: 1px solid #30363d;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 0.85rem;
    outline: none;
    cursor: pointer;
}

.action-btn {
    background-color: #21262d;
    color: #c9d1d9;
    border: 1px solid #30363d;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.action-btn:hover:not(:disabled) {
    background-color: #30363d;
    color: #f0f6fc;
}

.action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Table Architecture (Grid-like Alignment) */
.log-container {
    background-color: #161b22;
    border: 1px solid #30363d;
    border-radius: 6px;
    overflow: hidden;
}

.log-table-header {
    display: flex;
    width: 100%;
    background-color: #21262d;
    padding: 12px 10px;
    border-bottom: 1px solid #30363d;
    font-weight: 600;
    font-size: 0.85rem;
    color: #8b949e;
    letter-spacing: 0.5px;
    box-sizing: border-box;
}


.log-row {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #21262d;
    font-size: 0.85rem;
    box-sizing: border-box;
    transition: background-color 0.15s;
}

.log-row:hover {
    background-color: #1f242c !important;
}

/* Strict Column Width Distribution */
.h-col.host, .b-col.host {
    width: 15%;
    flex-shrink: 0;
}

.h-col.time, .b-col.time {
    width: 20%;
    flex-shrink: 0;
}

.h-col.detail, .b-col.detail {
    width: 15%;
    flex-shrink: 0;
    font-family: monospace;
}

.h-col.msg, .b-col.msg {
    width: 50%;
    flex-grow: 1;
    text-align: left;
    word-break: break-word;
    white-space: normal;
}

/* Container */
.olt-log-main {
    background-color: #0d1117;
    height: 100vh;
    display: flex;
    flex-direction: column;
    color: #c9d1d9;
}

/* Header - Compact */
.olt-log-header {
    background-color: #161b22;
    padding: 8px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #30363d;
}

.title-text {
    font-size: 1rem;
    margin: 0;
    font-weight: 700;
    letter-spacing: 1px;
    flex-grow: 1;
    text-align: center;
    color: #f0f6fc;
}

/* Controls এক লাইনে আনার জন্য */
.header-controls {
    display: flex;
    align-items: center;
    gap: 6px; /* এলিমেন্টগুলোর মাঝের গ্যাপ */
}

.back-button {
    background: #22c55e;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    max-width: 100px;
}

.back-button:hover { background: #2ea043; }

.olt-select {
    background: #0d1117;
    color: #c9d1d9;
    border: 1px solid #30363d;
    padding: 4px 8px;
    border-radius: 4px;
    min-width: 120px;
    font-size: 12px;
    outline: none;
}

.action-btn {
    background: #21262d;
    color: #c9d1d9;
    border: 1px solid #30363d;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: 0.2s;
}

.action-btn:hover {
    background: #30363d;
    border-color: #8b949e;
}

/* Table Structure */
.log-container {
    margin: 10px 15px; /* মার্জিন কমানো হয়েছে */
    background: #010409;
    border: 1px solid #30363d;
    border-radius: 6px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.log-table-header {
    display: flex;
    padding: 10px 15px;
    background: #161b22;
    border-bottom: 2px solid #30363d;
    font-size: 11px;
    font-weight: bold;
    color: #8b949e;
    text-transform: uppercase;
}

.log-rows-wrapper { overflow-y: auto; flex-grow: 1; }

.log-row {
    display: flex;
    padding: 8px 15px;
    border-bottom: 1px solid #21262d;
    font-family: 'Fira Code', 'Courier New', monospace;
    font-size: 12px;
    align-items: center;
}

.log-row:hover { background: #161b22; }

/* Fixed Column Widths */
.host { width: 130px; flex-shrink: 0; color: #58a6ff; }
.time { width: 180px; flex-shrink: 0; color: #8b949e; }
.detail { width: 160px; flex-shrink: 0; color: #f0f6fc; }
.msg { flex-grow: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Typography Inside Rows */
.log-date-label {
    display: block;
    font-size: 0.75rem;
    opacity: 0.6;
    margin-bottom: 2px;
}

.log-time-label {
    font-weight: 500;
}

.onu-tag {
    color: #58a6ff;
    font-weight: bold;
}

/* Row Color Coding Schemes */
.status-success {
    border-left: 4px solid #2ea043;
    background-color: rgba(46, 160, 67, 0.03);
    color: #56d364;
}

.status-danger {
    border-left: 4px solid #f85149;
    background-color: rgba(248, 81, 73, 0.03);
    color: #ff7b72;
}

.status-warning {
    border-left: 4px solid #d29922;
    background-color: rgba(210, 153, 34, 0.03);
    color: #e3b341;
}

.status-info {
    border-left: 4px solid #388bfd;
    background-color: rgba(56, 139, 253, 0.02);
    color: #c9d1d9;
}

/* Info Blocks */
.no-data {
    padding: 40px;
    text-align: center;
    color: #8b949e;
    font-size: 0.9rem;
}


.load-more-btn {
    background-color: #21262d;
    color: #c9d1d9;
    border: 1px solid #30363d;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    transition: all 0.2s;
}

.load-more-btn:hover {
    background-color: #30363d;
    border-color: #8b949e;
    color: #f0f6fc;
}

/* Custom Scrollbar */
.log-rows-wrapper::-webkit-scrollbar {
    width: 8px;
}
.log-rows-wrapper::-webkit-scrollbar-track {
    background: #0d1117;
}
.log-rows-wrapper::-webkit-scrollbar-thumb {
    background: #30363d;
    border-radius: 4px;
}
.log-rows-wrapper::-webkit-scrollbar-thumb:hover {
    background: #8b949e;
}

/* Responsive */
@media (max-width: 900px) {
    .log-table-header { display: none; }
    .log-row { flex-direction: column; align-items: flex-start; gap: 4px; padding: 12px; }
    .host, .time, .detail, .msg { width: 100%; white-space: normal; }
}`, "",{"version":3,"sources":["webpack://./src/components/LogManage/OltLog.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,qCAAqC;AACrC;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,8BAA8B;AAC5C;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,iBAAiB,EAAE,wBAAwB;IAC3C,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,oBAAoB,gBAAgB,EAAE,YAAY,EAAE;;AAEpD;IACI,aAAa;IACb,iBAAiB;IACjB,gCAAgC;IAChC,kDAAkD;IAClD,eAAe;IACf,mBAAmB;AACvB;;AAEA,iBAAiB,mBAAmB,EAAE;;AAEtC,wBAAwB;AACxB,QAAQ,YAAY,EAAE,cAAc,EAAE,cAAc,EAAE;AACtD,QAAQ,YAAY,EAAE,cAAc,EAAE,cAAc,EAAE;AACtD,UAAU,YAAY,EAAE,cAAc,EAAE,cAAc,EAAE;AACxD,OAAO,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAErF,2BAA2B;AAC3B;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,8BAA8B;IAC9B,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;IAC1C,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,oBAAoB,aAAa,EAAE;IACnC,WAAW,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,aAAa,EAAE;IACrF,8BAA8B,WAAW,EAAE,mBAAmB,EAAE;AACpE","sourcesContent":["/* Container */\n.olt-log-main {\n    background-color: #0d1117;\n    display: flex;\n    flex-direction: column;\n    color: #c9d1d9;\n}\n\n/* Header Container */\n.olt-log-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #161b22;\n    padding: 10px 15px;\n    border-radius: 6px;\n    border: 1px solid #30363d;\n    margin-bottom: 15px;\n}\n\n.title-text {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin: 0;\n    color: #f0f6fc;\n    letter-spacing: 0.5px;\n}\n\n/* Buttons and Controls */\n.back-button {\n    background-color: #238636;\n    color: #ffffff;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.back-button:hover {\n    background-color: #2ea043;\n}\n\n.header-controls {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.olt-select {\n    background-color: #21262d;\n    color: #c9d1d9;\n    border: 1px solid #30363d;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 0.85rem;\n    outline: none;\n    cursor: pointer;\n}\n\n.action-btn {\n    background-color: #21262d;\n    color: #c9d1d9;\n    border: 1px solid #30363d;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.action-btn:hover:not(:disabled) {\n    background-color: #30363d;\n    color: #f0f6fc;\n}\n\n.action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Table Architecture (Grid-like Alignment) */\n.log-container {\n    background-color: #161b22;\n    border: 1px solid #30363d;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.log-table-header {\n    display: flex;\n    width: 100%;\n    background-color: #21262d;\n    padding: 12px 10px;\n    border-bottom: 1px solid #30363d;\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: #8b949e;\n    letter-spacing: 0.5px;\n    box-sizing: border-box;\n}\n\n\n.log-row {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid #21262d;\n    font-size: 0.85rem;\n    box-sizing: border-box;\n    transition: background-color 0.15s;\n}\n\n.log-row:hover {\n    background-color: #1f242c !important;\n}\n\n/* Strict Column Width Distribution */\n.h-col.host, .b-col.host {\n    width: 15%;\n    flex-shrink: 0;\n}\n\n.h-col.time, .b-col.time {\n    width: 20%;\n    flex-shrink: 0;\n}\n\n.h-col.detail, .b-col.detail {\n    width: 15%;\n    flex-shrink: 0;\n    font-family: monospace;\n}\n\n.h-col.msg, .b-col.msg {\n    width: 50%;\n    flex-grow: 1;\n    text-align: left;\n    word-break: break-word;\n    white-space: normal;\n}\n\n/* Container */\n.olt-log-main {\n    background-color: #0d1117;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    color: #c9d1d9;\n}\n\n/* Header - Compact */\n.olt-log-header {\n    background-color: #161b22;\n    padding: 8px 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #30363d;\n}\n\n.title-text {\n    font-size: 1rem;\n    margin: 0;\n    font-weight: 700;\n    letter-spacing: 1px;\n    flex-grow: 1;\n    text-align: center;\n    color: #f0f6fc;\n}\n\n/* Controls এক লাইনে আনার জন্য */\n.header-controls {\n    display: flex;\n    align-items: center;\n    gap: 6px; /* এলিমেন্টগুলোর মাঝের গ্যাপ */\n}\n\n.back-button {\n    background: #22c55e;\n    color: white;\n    border: none;\n    padding: 8px 15px;\n    border-radius: 6px;\n    font-weight: bold;\n    cursor: pointer;\n    max-width: 100px;\n}\n\n.back-button:hover { background: #2ea043; }\n\n.olt-select {\n    background: #0d1117;\n    color: #c9d1d9;\n    border: 1px solid #30363d;\n    padding: 4px 8px;\n    border-radius: 4px;\n    min-width: 120px;\n    font-size: 12px;\n    outline: none;\n}\n\n.action-btn {\n    background: #21262d;\n    color: #c9d1d9;\n    border: 1px solid #30363d;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: 0.2s;\n}\n\n.action-btn:hover {\n    background: #30363d;\n    border-color: #8b949e;\n}\n\n/* Table Structure */\n.log-container {\n    margin: 10px 15px; /* মার্জিন কমানো হয়েছে */\n    background: #010409;\n    border: 1px solid #30363d;\n    border-radius: 6px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.log-table-header {\n    display: flex;\n    padding: 10px 15px;\n    background: #161b22;\n    border-bottom: 2px solid #30363d;\n    font-size: 11px;\n    font-weight: bold;\n    color: #8b949e;\n    text-transform: uppercase;\n}\n\n.log-rows-wrapper { overflow-y: auto; flex-grow: 1; }\n\n.log-row {\n    display: flex;\n    padding: 8px 15px;\n    border-bottom: 1px solid #21262d;\n    font-family: 'Fira Code', 'Courier New', monospace;\n    font-size: 12px;\n    align-items: center;\n}\n\n.log-row:hover { background: #161b22; }\n\n/* Fixed Column Widths */\n.host { width: 130px; flex-shrink: 0; color: #58a6ff; }\n.time { width: 180px; flex-shrink: 0; color: #8b949e; }\n.detail { width: 160px; flex-shrink: 0; color: #f0f6fc; }\n.msg { flex-grow: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n\n/* Typography Inside Rows */\n.log-date-label {\n    display: block;\n    font-size: 0.75rem;\n    opacity: 0.6;\n    margin-bottom: 2px;\n}\n\n.log-time-label {\n    font-weight: 500;\n}\n\n.onu-tag {\n    color: #58a6ff;\n    font-weight: bold;\n}\n\n/* Row Color Coding Schemes */\n.status-success {\n    border-left: 4px solid #2ea043;\n    background-color: rgba(46, 160, 67, 0.03);\n    color: #56d364;\n}\n\n.status-danger {\n    border-left: 4px solid #f85149;\n    background-color: rgba(248, 81, 73, 0.03);\n    color: #ff7b72;\n}\n\n.status-warning {\n    border-left: 4px solid #d29922;\n    background-color: rgba(210, 153, 34, 0.03);\n    color: #e3b341;\n}\n\n.status-info {\n    border-left: 4px solid #388bfd;\n    background-color: rgba(56, 139, 253, 0.02);\n    color: #c9d1d9;\n}\n\n/* Info Blocks */\n.no-data {\n    padding: 40px;\n    text-align: center;\n    color: #8b949e;\n    font-size: 0.9rem;\n}\n\n\n.load-more-btn {\n    background-color: #21262d;\n    color: #c9d1d9;\n    border: 1px solid #30363d;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.load-more-btn:hover {\n    background-color: #30363d;\n    border-color: #8b949e;\n    color: #f0f6fc;\n}\n\n/* Custom Scrollbar */\n.log-rows-wrapper::-webkit-scrollbar {\n    width: 8px;\n}\n.log-rows-wrapper::-webkit-scrollbar-track {\n    background: #0d1117;\n}\n.log-rows-wrapper::-webkit-scrollbar-thumb {\n    background: #30363d;\n    border-radius: 4px;\n}\n.log-rows-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #8b949e;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .log-table-header { display: none; }\n    .log-row { flex-direction: column; align-items: flex-start; gap: 4px; padding: 12px; }\n    .host, .time, .detail, .msg { width: 100%; white-space: normal; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
